import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const pendienteImporterSelectors = importerSelectors(
  'pendiente.importer',
);

export default pendienteImporterSelectors;
